// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__QxaMU","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__6e2L1","gfeWrapper":"CalendarEvent_gfeWrapper__3GPpc"};